import globeIcon from '@iconify/icons-bi/globe'
import bxGlobeIcon from '@iconify/icons-bx/bx-globe'
import bxTransfer from '@iconify/icons-bx/bx-transfer'
import feExternalLinkAlt from '@iconify/icons-fa-solid/external-link-alt'
import feArrowDown from '@iconify/icons-fe/arrow-down'
import feArrowUp from '@iconify/icons-fe/arrow-up'
import feClose from '@iconify/icons-fe/close'
import feahterChveronDown from '@iconify/icons-feather/chevron-down'
import feahterChveronLeft from '@iconify/icons-feather/chevron-left'
import feahterChveronRight from '@iconify/icons-feather/chevron-right'
import feahterChveronUp from '@iconify/icons-feather/chevron-up'
import { Icon, IconProps } from '@iconify/react'

const ret = (icon, props): React.ReactElement<IconProps, string | React.JSXElementConstructor<any>> => {
  const { inline, size, color, style, hFlip, vFlip, rotate, className } = props
  // <Icon icon={icon} {...(size && { height: size, width: size })} style={style} {...others} />
  return (
    <Icon
      icon={icon}
      color={color}
      width={size}
      height={size}
      rotate={rotate}
      hFlip={hFlip}
      vFlip={vFlip}
      inline={inline}
      style={style}
      className={className}
    />
  )
}

interface PropsType extends Partial<IconProps> {
  size?: number
  onClick?: () => void
}

type IconType = (props: PropsType) => React.ReactElement<IconProps, string | React.JSXElementConstructor<any>>

export const BxGlobeIcon: IconType = (props) => ret(bxGlobeIcon, props)
export const FeExternalLinkAlt: IconType = (props) => ret(feExternalLinkAlt, props)
export const FeArrowUp: IconType = (props) => ret(feArrowUp, props)
export const FeArrowDown: IconType = (props) => ret(feArrowDown, props)
export const BxTransfer: IconType = (props) => ret(bxTransfer, props)
export const FeClose: IconType = (props) => ret(feClose, props)
export const FeatherChevronLeft: IconType = (props) => ret(feahterChveronLeft, props)
export const FeatherChevronRight: IconType = (props) => ret(feahterChveronRight, props)
export const FeatherChevronDown: IconType = (props) => ret(feahterChveronDown, props)
export const FeatherChevronUp: IconType = (props) => ret(feahterChveronUp, props)
export const BiGlobeIcon: IconType = (props) => ret(globeIcon, props)
